<template>
    <div>
        <h1>진료 목적 건강정보(민감정보) 제3자 제공 동의</h1>
        주식회사 솔닥(이하 “회사”라 합니다)은 회원이 진료 예약, 진료 접수, 비대면 진료, 대면 진료 등 의료서비스 이용 과정에서 건강정보 공유를 선택한 경우, 회원이 선택한 건강정보를 해당 의료기관 또는 의료진에게 제공할 수 있습니다.<br>
        본 동의에서 “건강정보”란 회원이 솔닥 서비스를 통해 연동, 전송, 측정, 입력 또는 제출한 건강 관련 정보로서 개인을 식별할 수 있는 정보를 의미하며, 의료 마이데이터, 문진·증상·상담 정보 및 기타 진료 참고에 필요한 건강 관련 정보를 포함합니다.<br>
        회원은 아래 내용을 자세히 확인한 후 동의 여부를 결정할 수 있습니다.<br>
        본 동의는 진료 목적의 건강정보 공유 기능 이용을 위해 필요한 동의입니다. 동의하지 않더라도 솔닥 건강정보 기본 조회 서비스 및 일반 진료 신청에는 제한이 없습니다. 다만, 선택한 건강정보를 의료기관 또는 의료진에게 제공하는 기능은 이용할 수 없습니다.<br>
        <h3>이번 진료 건의 제공 내용</h3>
        <table class="table" border="1">
            <thead>
                <tr>
                    <th style="width: 30%;">구분</th>
                    <th style="width: 70%;">내용</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>제공받는 자</td>
                    <td>{{ hospitalName }}</td>
                </tr>
                <tr>
                    <td>제공 목적</td>
                    <td>진료 건의 진료, 상담, 처방 및 진료 전 참고</td>
                </tr>
                <tr>
                    <td>제공 항목</td>
                    <td>{{ providedItems }}</td>
                </tr>
                <tr>
                    <td>의료진 열람 기간</td>
                    <td>예약 시점부터 처방일 종료기간까지</td>
                </tr>
            </tbody>
        </table>
        <h3>제1조 (제공 목적)</h3>
        1. 회사는 회원이 선택한 건강정보를 비대면 진료, 대면 진료, 진료 예약 또는 접수 등 의료서비스 이용 과정에서 해당 의료기관 또는 의료진의 진료, 상담, 처방 및 진료 전 참고자료로 활용될 수 있도록 제공할 수 있습니다.<br>
        2. 회사는 본 동의에 따라 제공되는 건강정보를 회원이 선택한 진료 건의 진료 목적 범위 내에서만 제공합니다.<br>
        <h3>제2조 (제공받는 자)</h3>
        1. 본 동의에 따라 건강정보를 제공받는 자는 다음과 같습니다.<br>
        &nbsp;&nbsp;- 의료기관: {{ hospitalName }}<br>
        2. 제1항의 제공받는 자는 회원이 이번 진료 예약, 진료 접수 또는 진료 신청 과정에서 직접 선택한 의료기관 또는 의료진이며, 본 동의는 해당 진료 건에 한하여 효력이 있습니다. 다른 의료기관 또는 다른 진료 건에 건강정보를 제공하려는 경우에는 그때마다 별도의 동의를 받습니다.<br>
        3. 의료기관 또는 의료진이 솔닥 EMR 등 회사가 제공하는 의료진용 서비스를 통해 회원의 건강정보를 열람하는 경우에도, 해당 의료기관 또는 의료진이 진료 목적의 독립적인 개인정보처리자로서 건강정보를 제공받는 것으로 볼 수 있습니다.<br>
        4. 회사가 의료기관 또는 의료진에게 제공하는 건강정보는 해당 진료 건의 진료 참고를 위한 열람 형태로 제공되며, 원본 건강정보는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않습니다.<br>
        <h3>제3조 (제공하는 건강정보 항목)</h3>
        1. 회원이 이번 진료 건에서 제공하기로 선택한 건강정보 항목은 다음과 같습니다.<br>
        <span v-for="(item, index) in selectedItems" :key="index">&nbsp;&nbsp;- {{ item }}<br></span>
        2. 회사는 제1항에 표시된 항목에 한하여 의료기관 또는 의료진에게 제공하며, 회원이 선택하지 않은 건강정보는 제공하지 않습니다.<br>
        3. 회원은 동의 전 화면에서 제1항의 항목을 변경할 수 있으며, 항목을 변경하면 변경된 내용이 본 동의서에 다시 표시됩니다.<br>
        <h3>제4조 (제공받는 자의 열람 및 이용기간)</h3>
        1. 제공받는 자는 회원이 선택한 건강정보를 해당 진료 건의 진료, 상담 및 처방을 위한 참고 목적으로 열람·이용할 수 있습니다.<br>
        2. 의료진이 진료 과정에서 해당 건강정보를 참고하여 별도로 작성한 진료기록, 소견, 처방 등은 관계 법령에 따른 진료기록 보존 기준에 따라 보관될 수 있습니다. 다만, 회사가 제공한 원본 건강정보는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않습니다.<br>
        3. 건강정보는 진료 예약 시점부터 처방전 사용기간 만료일까지 열람할 수 있습니다. 처방전이 발급되지 않은 경우에는 해당 의료기관이 정한 열람기간까지 열람할 수 있으며, 열람기간이 종료되면 의료기관 또는 의료진에게 더 이상 노출되지 않습니다.<br>
        4. 해당 진료가 취소된 경우에는 열람기간이 남아 있더라도 의료기관 또는 의료진에게 건강정보가 더 이상 노출되지 않습니다.<br>
        5. 회원이 본 동의 또는 해당 진료 건에 대한 건강정보 제공 동의를 철회하거나, 건강정보 연동 해지, 회원 탈퇴 등으로 회사가 해당 정보를 더 이상 처리할 수 없는 경우에는 열람이 중단됩니다.<br>
        6. 제공받는 자의 구체적인 개인정보 처리 및 파기 기준은 관계 법령 및 해당 의료기관 또는 의료진의 개인정보처리방침에 따릅니다.<br>
        <h3>제5조 (회사의 보유 및 관리)</h3>
        1. 회사는 본 동의에 따른 건강정보 제공 내역을 관계 법령, 가이드라인 및 서비스 운영 정책에 따라 보관·관리할 수 있습니다.<br>
        2. 제공 내역에는 제공받는 자, 제공 목적, 제공 항목, 제공 일시, 진료 건 정보, 동의 일시 등이 포함될 수 있습니다.<br>
        3. 회원은 서비스 내 건강정보 관리 화면 또는 회사가 정한 절차를 통해 건강정보 제공 이력을 확인할 수 있습니다.<br>
        <h3>제6조 (동의 거부·철회 및 제공 후 처리)</h3>
        1. 회원은 본 건강정보 제3자 제공 동의를 거부할 수 있으며, 동의하지 않더라도 솔닥 의료 건강정보 기본 조회 서비스 이용에는 제한이 없습니다. 다만, 진료 목적 건강정보 공유 기능은 이용할 수 없습니다.<br>
        2. 회원은 건강정보가 의료기관 또는 의료진에게 제공되기 전까지 서비스 화면 또는 회사가 정한 절차를 통해 본 동의를 철회할 수 있습니다.<br>
        3. 회원이 본 동의를 철회하는 경우 회사는 해당 진료 건에 대한 건강정보 제공을 중단합니다.<br>
        4. 이미 의료기관 또는 의료진에게 열람 제공된 건강정보는 제공 이후 회사가 해당 의료진의 열람 사실 자체를 취소할 수는 없습니다. 다만, 원본 건강정보는 의료기관 또는 의료진의 시스템에 별도로 저장되지 않으며, 의료진이 이를 참고하여 작성한 진료기록 등은 관계 법령에 따라 보관될 수 있습니다.
    </div>
</template>

<script>
var DEFAULT_HOSPITAL_NAME = '솔닥제휴병원';
var DEFAULT_ITEM_TEXT = '선택한항목';

export default {
    name: 'mydataMedicalThirdParty',
    computed: {
        hospitalName: function()
        {
            return this.$route.query.hospital_name || DEFAULT_HOSPITAL_NAME;
        },
        providedItems: function()
        {
            var query = this.$route.query;
            var items = [query.public_data_items, query.mydata_institutions, query.soldoc_records]
                .filter(function(item) { return item; });

            return items.length > 0 ? items.join(', ') : DEFAULT_ITEM_TEXT;
        },
        selectedItems: function()
        {
            // 쉼표 또는 개행으로 구분된 선택 항목 목록을 줄 단위로 표시합니다.
            var raw = this.$route.query.selected_items || '';
            var items = raw.split(/[\n,]/)
                .map(function(item) { return item.trim(); })
                .filter(function(item) { return item; });

            return items.length > 0 ? items : [DEFAULT_ITEM_TEXT];
        }
    }
}
</script>

<style scoped>
    .table {
      width: 100%;
      border-collapse: collapse;
      word-break: break-word;
    }
    th, td {
      padding: 8px;
      vertical-align: top;
      text-align: left;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/mydata/MedicalThirdParty.vue